import api from "@/libs/axios";
import { HttpResponse } from "@/pages/taskpane/lib/api/types/AxiosMethod";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { GetSuggestTimeResponse, IGetSuggestTimeRequest } from "./entities/suggestTimeEntity";

export const getSuggestTime = async (
  payload: IGetSuggestTimeRequest
): Promise<HttpResponse<GetSuggestTimeResponse>> => {
  const response = await api.post(apiEnum.getSuggestTime, payload);
  if(response.data?.data) {
    response.data = response.data.data;
  }
  return new HttpResponse<GetSuggestTimeResponse>(response, GetSuggestTimeResponse);
};
